import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../assets/css/styles.css';
import "../assets/css/Services.css";
import service1 from '../assets/images/service-1.png';
import service2 from '../assets/images/service-2.png';
import service3 from '../assets/images/service-3.png';
import service4 from '../assets/images/service-4.png';
import service5 from '../assets/images/service-5.png';
import service6 from '../assets/images/service-6.png';
import service7 from '../assets/images/service-7.png';
import service8 from '../assets/images/service-8.png';
import hero_logo from '../assets/images/hero_logo.svg';
import { LanguageContext } from '../contexts/LanguageContext';
import HighlightsCarousel from '../components/HighlightsCarousel';

const HeroSection = ({ title, subtitle }) => (
  <header className="hero">
    <div className="hero-overlay">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </header>
);

const IntroSection = () => {
  const { t } = useContext(LanguageContext);
  return (
    <div className="intro-overlay">
      <p>
        {t.what_we_do_description_p_1}
        <br /><br />
        {t.what_we_do_description_p_2}
      </p>
    </div>
  );
}

const MissionVision = () => {
  const { t } = useContext(LanguageContext);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const history = useHistory();

  const services = [
    { icon: service1, title: t.security_guarding, description: t.security_guarding_description },
    { icon: service2, title: t.security_consulting, description: t.security_consulting_description },
    { icon: service3, title: t.elite_security, description: t.elite_security_description },
    { icon: service4, title: t.electronic, description: t.electronic_description },
    { icon: service5, title: t.k9, description: t.k9_description },
    { icon: service6, title: t.escort, description: t.escort_description },
    { icon: service7, title: t.cybersecurity, description: t.cyber_description },
    { icon: service8, title: t.airport, description: t.airport_description }
  ];

  const servicesData = [
    { icon: service1, title: t.security_guarding, description: t.security_guarding_serv_description },
    { icon: service2, title: t.security_consulting, description: t.security_consulting_serv_description },
    { icon: service3, title: t.elite_security, description: t.elite_security_serv_description },
    { icon: service4, title: t.electronic, description: t.electronic_serv_description },
    { icon: service5, title: t.k9, description: t.k9_serv_description },
    { icon: service6, title: t.escort, description: t.escort_serv_description },
    { icon: service7, title: t.cybersecurity, description: t.cybersecurity_serv_description },
    { icon: service8, title: t.airport, description: t.airport_serv_description }
  ];

  const handleActionClick = () => {
    history.push('/contact-us');
  };

  return (
    <section className="section-2">
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-tile">
            <img src={service.icon} alt={service.title} className="service-icon" />
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <button className="service-btn" onClick={() => setSelectedIndex(index)}>
              {t.home_section_2_service_btn}
            </button>
          </div>
        ))}
      </div>

      {selectedIndex !== null && (
        <div className="modal-overlay" onClick={() => setSelectedIndex(null)}>
          <div className="modal-content scrollable" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedIndex(null)}>&times;</button>
            <h2>{servicesData[selectedIndex].title}</h2>
            <img src={servicesData[selectedIndex].icon} alt={servicesData[selectedIndex].title} className="modal-icon" />
            <p>{servicesData[selectedIndex].description}</p>
            <button className="action-btn" onClick={handleActionClick}>{t.request_a_quote}</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default function AboutUs() {
  const { t } = useContext(LanguageContext);
  return (
    <>
      <HeroSection title={t.what_we_do} subtitle="" />
      <IntroSection />
      <MissionVision />
      <div className="news-section">
        <p>{t.our_blog}</p>
        <h2>
          <span className="highlight">{t.news_section_highlight} </span>{t.news_section_opening}
        </h2>
        <p className="opening">{t.news_section_description}</p>
        <HighlightsCarousel />
      </div>
    </>
  );
}
